/**
 * Helpers puros de colas
 */
import Utils from "../../../utils/Utils";

/**
 * Una cola sin nombre no tiene slug: navegar a registro/pantalla/gestor
 * daría una URL con segmento vacío
 */
export const colaSinNombre = (cola) => !String(cola?.nombre ?? "").trim();

/**
 * Ruta de una pantalla de la cola. Contrato de URL del legacy: PantallaTurnos,
 * RegistroTurno y el gestor leen ?id=; el slug del nombre es solo legible
 */
export const rutaCola = (cola, accion) => `/colas/${Utils.slugify(cola.nombre)}/${accion}?id=${cola.id}`;
